import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from "pdfmake/build/vfs_fonts"
import { HeaderPDF, ProdutoEstoque } from '../../../Utils/Types';
import { Funcoes } from '../../../Utils/Funcoes';

export class RelProdutosEstoquePDF {

  private headers: HeaderPDF[] = []
  private produtoEstoqueList: ProdutoEstoque[]
  private body: any
  private corpoDocumento: any
  private totalProdutos: any
  private totalPrecoVenda: any
  private totalPrecoCusto: any
  private dadosEmpresa: any

  constructor(produtoEstoqueList: ProdutoEstoque[], totalProdutos: any, totalPrecoVenda: any, totalPrecoCusto: any) {
    this.produtoEstoqueList = produtoEstoqueList
    this.totalProdutos = totalProdutos
    this.totalPrecoVenda = totalPrecoVenda
    this.totalPrecoCusto = totalPrecoCusto
  }

  /*
  async CriaDocumento() {
      const bBody: any = this.produtoEstoqueList.map((prodEstoque) => {
          return [
            { text: prodEstoque.descricao, fontSize: 10 },
            { text: prodEstoque.estoque_fisico, fontSize: 10 },
            { text: prodEstoque.preco_c, fontSize: 10 },
            { text: prodEstoque.preco_v, fontSize: 10 },
            { text: prodEstoque.total_custo, fontSize: 10 },
            { text: prodEstoque.total_venda, fontSize: 10 },
          ]
      })

      this.body = [
          { text: "Descrição", fontSize: 10 },
          { text: "Estoque", fontSize: 10 },
          { text: "Preço de Custo", fontSize: 10 },
          { text: "Total de Custo", fontSize: 10 },
          { text: "Preço de Venda", fontSize: 10 },
          { text: "Total de Venda", fontSize: 10 },
      ]

      const lineHeader = [
          {
            text: '____________________________________________________________________________________________________________________________________________________________________________',
            aligment: 'center',
            fontSize: 5,
            colSpan: 3
          }, {}, {},
      ]

      let content = [this.headers, lineHeader];
      content = [...content, ...this.body];
      this.corpoDocumento = content;
  }
  */

  /*
  GerarDocumento() {

      const document = {
        pageSize: 'A4',
        pageMargins: [2, 53, 2, 48],
        header: () => {
          return {
            margin: [2, 12, 2, 0],
            layout: 'noBorders',
            table: {
              widths: ['*'],
              body: [
                [
                  { text: 'Relatório de Produtos em Estoque', style: 'reportName' }
                ]
              ],
            },
          };
        },
        content: [
          {
            layout: 'noBorders',
            table: {
              headerRows: 1,
              widths: ['*', 55, 55],
              body: this.corpoDocumento
            }
          },
        ],
        footer: (currentPage: number, pageCount: number) => {
          return {
            layout: 'noBorders',
            margin: [2, 0, 2, 22],
            table: {
              widths: ['auto'],
              body: [
                [
                  {
                    text: '_________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________',
                    alignment: 'center',
                    fontSize: 5,
                  },
                ],
                [
                  [
                    {
                      text: `Página ${currentPage.toString()} de ${pageCount}`,
                      fontSize: 7,
                      alignment: 'right',
                      // horizontal, vertical
                      margin: [3, 0],
                    },
                    {
                      text: '© Lojinha de TI',
                      fontSize: 7,
                      alignment: 'center',
                    },
                  ],
                ],
              ],
            },
          };
        },
        styles: {
          reportName: {
            fontSize: 9,
            bold: true,
            alignment: 'center',
            margin: [0, 4, 0, 0],
          }
        },
      };
  
      return document;
  }
  */

  async GerarPDF(produtoEstoqueList: ProdutoEstoque[]) {

    this.dadosEmpresa = Funcoes.GetDadosEmpresa()

    pdfMake.vfs = pdfFonts.pdfMake.vfs

    let dados = produtoEstoqueList.map((item: ProdutoEstoque) => {
      return [
        { text: item.descricao, alignment: 'left', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true], },
        { text: Funcoes.numberFormat(item.estoque_fisico, 'decimal', 2, 2,), alignment: 'right', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true], },
        { text: Funcoes.numberFormat(item.preco_c, 'currency', 2, 2,), alignment: 'right', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true], },
        { text: Funcoes.numberFormat(item.preco_v, 'currency', 2, 2,), alignment: 'right', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true], },
        { text: Funcoes.numberFormat(item.total_custo, 'currency', 2, 2,), alignment: 'right', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true], },
        { text: Funcoes.numberFormat(item.total_venda, 'currency', 2, 2,), alignment: 'right', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, false, true], },
      ]
    })

    const details: any = [
      {
        layout: 'noBorders',
        margin: 0,
        table: {
          widths: ['*', '*', '*', '*', '*', '*'],
          body: dados
        },
      }
    ]

    const footer = (currentPage: number, pageCount: number,) => {
      return [
        {
          layout: 'Borders',
          style: 'tableExample',
          margin: [5, 20, 5, 0],
          table: {
            headerRows: 1,
            widths: ['*'],
            body: [
              [{ text: 'Pág. ' + currentPage + '/' + pageCount, alignment: 'right', fontSize: 10, margin: [0, 0, 0, 0], border: [false, true, false, false] }],
            ]
          }
        },
      ]
    };

    const docDefinitions: any = {
      pageSize: 'A4',
      pageMargins: [5, 5, 5, 50],
      content: [
        /* Dados da Empresa Início */
        {
          layout: 'Borders',
          style: 'tableExample',
          table: {
            headerRows: 1,
            widths: ['*'],
            body: [
              [{ text: this.dadosEmpresa?.fantasia || '', bold: true, alignment: 'center', margin: [0, 2, 0, 0], fontSize: 13, border: [false, false, false, false] },],
              [{ text: 'CNPJ: ' + (Funcoes.FormatDoc(this.dadosEmpresa?.cnpj_cpf) || ''), bold: true, alignment: 'center', margin: [0, 0, 0, 0], fontSize: 13, border: [false, false, false, false] },],
              [{ text: (this.dadosEmpresa?.endereco || '') + (this.dadosEmpresa?.numero ? " N." + this.dadosEmpresa?.numero : '') + ' ' + (this.dadosEmpresa?.bairro || ''), bold: true, alignment: 'center', margin: [0, 0, 0, 0], fontSize: 13, border: [false, false, false, false] },],
              [{ text: (this.dadosEmpresa?.cidade || '') + " - " + (this.dadosEmpresa?.uf || ''), bold: true, alignment: 'center', margin: [0, 0, 0, 0], fontSize: 13, border: [false, false, false, false] },],
            ],
          },
        },
        /* Dados da Empresa Fim*/

        {
          layout: 'Borders',
          style: 'tableExample',
          table: {
            headerRows: 1,
            widths: ['*'],
            body: [
              [{ text: 'Relatório de Produtos em Estoque', alignment: 'center', bold: true, fontSize: 12, border: [false, false, false, false], style: 'header', margin: [0, 0, 0, 2] },],
            ],
          },
        },



        {
          layout: 'Borders',
          style: 'tableExample',
          table: {
            widths: ['25%', '15%', '15%', '15%', '15%', '15%'],
            body: [
              [
                { text: 'Descrição', alignment: 'center', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, true, false] },
                { text: 'Estoque', alignment: 'center', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, true, false] },
                { text: 'Preço de Custo', alignment: 'center', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, true, false] },
                { text: 'Total de Custo', alignment: 'center', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, true, false] },
                { text: 'Preço de Venda', alignment: 'center', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, true, false] },
                { text: 'Total de Venda', alignment: 'center', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, false, false] },
              ],
            ],
          },
        },

        {
          layout: 'Borders',
          style: 'tableExample',
          margin: [0, 0, 0, 0],
          table: {
            widths: ['25%', '15%', '15%', '15%', '15%', '15%'],
            body: dados
          },
        },

        {
          layout: 'Borders',
          style: 'tableExample',
          margin: [0, 10, 0, 0],
          table: {
            headerRows: 1,
            widths: ['*', '*', '*'],
            body: [

              [
                { text: 'Produtos em Estoque: ' + this.totalProdutos, bold: true, margin: [0, 0, 0, 0], alignment: 'left', fontSize: 10, border: [false, true, false, true] },
                { text: 'Total do Preço de Custo: ' + this.totalPrecoCusto, bold: true, margin: [0, 0, 0, 0], alignment: 'left', fontSize: 10, border: [false, true, false, true] },
                { text: 'Total do Preço de Venda: ' + this.totalPrecoVenda, bold: true, margin: [0, 0, 0, 0], alignment: 'left', fontSize: 10, border: [false, true, false, true] },
              ]
            ],
          },
        },

      ],
      footer: footer
    };

    pdfMake.createPdf(docDefinitions).print();

  }

}